interface WaveDividerProps {
  fromColor: string;
  toColor: string;
  flip?: boolean;
  fromImage?: string;
}

export default function WaveDivider({ fromColor, toColor, flip = false, fromImage }: WaveDividerProps) {
  return (
    <div
      className="relative w-full overflow-hidden"
      style={{
        height: "70px",
        background: fromImage
          ? `url(${fromImage}) center bottom / cover no-repeat`
          : fromColor,
        lineHeight: 0,
        marginBottom: "-1px",
      }}
    >
      <svg
        viewBox="0 0 1440 70"
        preserveAspectRatio="none"
        style={{ display: "block", width: "100%", height: "100%" }}
        className={flip ? "scale-x-[-1]" : ""}
      >
        <path
          d="M0,35 C180,70 360,0 540,35 C720,70 900,0 1080,35 C1260,70 1350,15 1440,35 L1440,70 L0,70 Z"
          fill={toColor}
        />
      </svg>
    </div>
  );
}
